import { render, staticRenderFns } from "./TreeCanvas.vue?vue&type=template&id=2268624a&scoped=true"
import script from "./TreeCanvas.vue?vue&type=script&lang=js"
export * from "./TreeCanvas.vue?vue&type=script&lang=js"
import style0 from "./TreeCanvas.vue?vue&type=style&index=0&id=2268624a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268624a",
  null
  
)

export default component.exports